import { Coins, DollarSign, Droplets, BarChart3, Users, Repeat, TrendingUp, TrendingDown } from 'lucide-react';
import { formatSmallPrice } from '../../lib/utils';

export const MainStatsBanner = ({ liquidity, dexMetrics, krownHolders, priceChange24h, priceChangeAvailable }) => {
  if (!liquidity?.summary) return null;
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-2 sm:gap-4">
      <div className="p-3 sm:p-4 rounded-xl bg-gradient-to-br from-emerald-500/10 to-emerald-500/5 border border-emerald-500/20 col-span-2 sm:col-span-1">
        <div className="flex items-center gap-1 sm:gap-2 mb-1 sm:mb-2">
          <Coins className="w-4 h-4 sm:w-5 sm:h-5 text-emerald-500 flex-shrink-0" />
          <p className="text-xs sm:text-sm text-muted-foreground">KROWN Price</p>
        </div>
        <div>
          <p className="text-sm sm:text-lg font-bold text-emerald-600 font-mono whitespace-nowrap">{formatSmallPrice(liquidity.summary.krown_price_usd_raw)}</p>
          {priceChangeAvailable && priceChange24h !== null && (
            <div className={`flex items-center gap-1 text-xs sm:text-sm mt-1 ${priceChange24h >= 0 ? 'text-emerald-500' : 'text-red-500'}`}>
              {priceChange24h >= 0 ? <TrendingUp className="w-3 h-3" /> : <TrendingDown className="w-3 h-3" />}
              <span>{priceChange24h >= 0 ? '+' : ''}{priceChange24h.toFixed(2)}%</span>
            </div>
          )}
        </div>
      </div>
      <div className="p-3 sm:p-4 rounded-xl bg-gradient-to-br from-blue-500/10 to-blue-500/5 border border-blue-500/20">
        <div className="flex items-center gap-1 sm:gap-2 mb-1 sm:mb-2">
          <DollarSign className="w-4 h-4 sm:w-5 sm:h-5 text-blue-500 flex-shrink-0" />
          <p className="text-xs sm:text-sm text-muted-foreground">Market Cap</p>
        </div>
        <p className="text-base sm:text-xl font-bold text-blue-600">${liquidity.summary.market_cap_usd || 'N/A'}</p>
      </div>
      <div className="p-3 sm:p-4 rounded-xl bg-gradient-to-br from-violet-500/10 to-violet-500/5 border border-violet-500/20">
        <div className="flex items-center gap-1 sm:gap-2 mb-1 sm:mb-2">
          <Droplets className="w-4 h-4 sm:w-5 sm:h-5 text-violet-500 flex-shrink-0" />
          <p className="text-xs sm:text-sm text-muted-foreground">Liquidity</p>
        </div>
        <p className="text-base sm:text-xl font-bold text-violet-600">${liquidity.summary.total_liquidity_usd}</p>
      </div>
      <div className="p-3 sm:p-4 rounded-xl bg-gradient-to-br from-amber-500/10 to-amber-500/5 border border-amber-500/20">
        <div className="flex items-center gap-1 sm:gap-2 mb-1 sm:mb-2">
          <BarChart3 className="w-4 h-4 sm:w-5 sm:h-5 text-amber-500 flex-shrink-0" />
          <p className="text-xs sm:text-sm text-muted-foreground">24H Vol</p>
        </div>
        <p className="text-base sm:text-xl font-bold text-amber-600">
          ${typeof dexMetrics?.last_24h?.volume_usd === 'number'
            ? dexMetrics.last_24h.volume_usd.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            : dexMetrics?.last_24h?.volume_usd || '0.00'}
        </p>
      </div>
      <div className="p-3 sm:p-4 rounded-xl bg-gradient-to-br from-cyan-500/10 to-cyan-500/5 border border-cyan-500/20">
        <div className="flex items-center gap-1 sm:gap-2 mb-1 sm:mb-2">
          <Users className="w-4 h-4 sm:w-5 sm:h-5 text-cyan-500 flex-shrink-0" />
          <p className="text-xs sm:text-sm text-muted-foreground">Holders</p>
        </div>
        <p className="text-base sm:text-xl font-bold text-cyan-600">{krownHolders.toLocaleString()}</p>
      </div>
      <div className="p-3 sm:p-4 rounded-xl bg-gradient-to-br from-pink-500/10 to-pink-500/5 border border-pink-500/20">
        <div className="flex items-center gap-1 sm:gap-2 mb-1 sm:mb-2">
          <Repeat className="w-4 h-4 sm:w-5 sm:h-5 text-pink-500 flex-shrink-0" />
          <p className="text-xs sm:text-sm text-muted-foreground">24H Swaps</p>
        </div>
        <p className="text-base sm:text-xl font-bold text-pink-600">
          {(dexMetrics?.last_24h?.swap_count || dexMetrics?.last_24h?.swap_txn_count || 0).toLocaleString()}
        </p>
      </div>
    </div>
  );
};
